import React, { useState } from "react";
import styles from './LayoutList.module.css';
import LayoutCard from '../LayoutCard/LayoutCard';
import LayoutEdit from '../LayoutEdit/LayoutEdit';
import { createLayout } from '../../api/layoutApi';
import { useNavigate } from 'react-router-dom';

const LayoutList = ({ layouts }) => {
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [layout, setLayout] = useState(null);
    const navigate = useNavigate();

    const handleClickDetail = (layoutId) => {
        navigate(`/layout/${layoutId}`);
    };

    const handleAddLayout = async (layoutData) => {
        try {
            const newLayout = await createLayout(layoutData);
            // Refresh the layouts list after adding
            setLayout(newLayout);
            return newLayout;
        } catch (error) {
            console.error('Error creating layout:', error);
            throw error;
        }
    };

    return (
        <div className={styles.layoutListContainer}>
            <div className={styles.layoutListHeader}>
                <h1>Layouts</h1>
                <button 
                    className={styles.addLayoutButton}
                    onClick={() => setIsAddModalOpen(true)}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="12" y1="8" x2="12" y2="16"/>
                        <line x1="8" y1="12" x2="16" y2="12"/>
                    </svg>
                    Add Layout
                </button>
            </div>

            {!layouts || layouts.length === 0 ? (
                <div className={styles.noLayouts}>
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                        <circle cx="8.5" cy="8.5" r="1.5"/>
                        <polyline points="21 15 16 10 5 21"/>
                    </svg>
                    <p>No layouts available</p>
                    <button 
                        className={styles.addFirstLayout}
                        onClick={() => setIsAddModalOpen(true)}
                    >
                        Create Your First Layout
                    </button>
                </div>
            ) : (
                <div className={styles.layoutList}>
                    {layouts.map(layout => (
                        <LayoutCard 
                            key={layout._id} 
                            layout={layout} 
                            handleClickDetail={handleClickDetail} 
                        />
                    ))}
                </div>
            )}

            <LayoutEdit
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
                onSave={handleAddLayout}
            />
        </div>
    );
};

export default LayoutList;
